<template>
  <div
    ref="card-politica-de-privacidade"
    class="card-politica-de-privacidade-container"
  >
    <div class="card-politica-de-privacidade">
      <p v-html="wl.strings['card-politica-de-privacidade']" />
      <div class="card-politica-de-privacidade-button-container">
        <Button
          size="md"
          :color="wl.colors.secondary"
          :text-color="wl.colors.on.secondary"
          :text="wl.strings['card-politica-de-privacidade-btn-concordo']"
          style="margin-right: 5px"
          @click="() => { confirm() }"
        />
        <Button
          size="md"
          :color="wl.colors.secondary"
          outlined
          :text-color="wl.colors.on.secondary"
          :text="wl.strings['card-politica-de-privacidade-btn-sair']"
          style="margin-left: 5px; min-width: 113px"
          @click="() => { close() }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@components/Button'
export default {
  components: {
    Button
  },
  mounted () {
    const accepted = localStorage.getItem('accepted-privacy-policy')
    if (accepted !== 'true') {
      this.$refs['card-politica-de-privacidade'].classList.add('open')
    }
  },
  methods: {
    close () {
      this.$refs['card-politica-de-privacidade'].classList.remove('open')
      setTimeout(() => {
        this.$refs['card-politica-de-privacidade'].style.display = 'none'
      }, 150)
    },
    confirm () {
      localStorage.setItem('accepted-privacy-policy', 'true')
      this.close()
    }
  }

}
</script>

<style scoped>
  .card-politica-de-privacidade-container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    pointer-events: none;
    display: flex;
  }
  .card-politica-de-privacidade-container.open > .card-politica-de-privacidade{
    opacity: 1;
    transform: scale(1);
  }
  .card-politica-de-privacidade {
    transition: opacity 150ms ease, transform 150ms ease,;
    opacity: 0;
    transform: scale(0.8);
    pointer-events: all;
    background-color: rgba(255, 255, 255, 1);
    max-width: 600px;
    color: #5D5D5D;
    border-radius: 10px;
    padding: 15px;
    font: normal 12px/20px 'Open Sans';
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0,0,0,.12);
    backdrop-filter: blur(15px);
  }
  .card-politica-de-privacidade-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
